import { createRouter, createWebHistory } from 'vue-router'

// Import route components

//import LiveView from '../views/LiveView.vue'

import Login from '@/components/LoginDialog.vue';
import { useAuthStore } from '@/stores/auth';
import BillboardPub from '@/views/BillboardPub.vue';
//import AhMayDashboard from '@/views/AhMayDashboard.vue';

// Define routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component:()=>import('@/views/Home.vue'),
    meta: { 
      requiresAuth: true,
      title: '即時影像'
    },
    children: [
      {
        path: 'dashboard/:areaId',
        name: 'DashBoard',
        component: ()=>import('@/views/Dashboard.vue'),
        meta: { 
          requiresAuth: true,
          title: '資訊看板'
        },
        props: (route) => ({ areaId: Number(route.params.areaId)}),
      },
      {
        path: 'devicestatus',
        name: 'DeviceStatus',
        component: ()=>import('@/views/DeviceStatus.vue'),
        meta: { 
          requiresAuth: true,
          title: '戰情資料'
        },
        props: (route) => ({ areaId: Number(route.params.areaId)}),
      },
      {
        path: 'humanflow3/:areaId',
        name: 'HumanFlow3',
        component: ()=>import('@/views/HumanFlow3.vue'),
        meta: { 
          requiresAuth: true,
          title: '人流統計'
        },
        props: (route) => ({ areaId: Number(route.params.areaId)}),
      },
      {
        path: 'livegridview3/:userId', 
        name: 'LiveGridView3',
        component: ()=>import('@/views/LiveGridView20250227.vue'),
        
        meta: { 
          requiresAuth: true,
          title: '即時分割影像'
        },
        props: route => ({ userId:String(route.params.userId) }),
      },
    ]
  },
  
  
  /*
  {
    path: '/humanflow/:areaId',
    name: 'HumanFlow',
    component: ()=>import('@/views/HumanFlow.vue'),
    meta: { 
      requiresAuth: true,
      title: '人流統計'
    },
    props: (route) => ({ areaId: Number(route.params.areaId)}),
  },
  */
  {
    path: '/special/:areaId',
    name: 'Special',
    component: BillboardPub,
    meta: { 
      requiresAuth: false,
      title: '人流統計'
    },
    props: (route) => ({ areaId: Number(route.params.areaId)}),
  },
  /*
  {
    path: '/ahmaydashboard',
    name: 'AhmayDashboard',
    component:()=>import('@/views/AhMayDashboard.vue'),
    //component: AhMayDashboard,
    meta: { 
      requiresAuth: true,
      title: '阿美看板'
    },
    
  },
  */
  {
    path: '/ahmaymanage',
    name: 'AhmayManage',
    component:()=>import('@/views/AhMayManage.vue'),
    //component: AhMayDashboard,
    meta: { 
      requiresAuth: true,
      title: '阿美看板管理'
    },
    
  },
  /*
  {
    path: '/ahmayeditor',
    name: 'AhmayEditor',
    component:()=>import('@/views/AhMayEditor.vue'),
    //component: AhMayDashboard,
    meta: { 
      requiresAuth: true,
      title: '阿美看板編輯'
    },
    
  },
  */
  {
    path: '/ahmaydashboard3',
    name: 'AhmayDashboard3',
    component:()=>import('@/views/AhMayDashboard3.vue'),
    //component: AhMayDashboard,
    meta: { 
      requiresAuth: false,
      title: '阿美看板3'
    },
    props: (route) => ({ 
      name: route.params.name,  // Remove the 'string' keyword
      secs: Number(route.params.secs)
    })
    //props: (route) => ({ name:string (route.params.name), secs : Number(route.params.secs)}),
  },
  /*
  {
    path: '/ahmaydashboard4',
    name: 'AhmayDashboard4',
    component:()=>import('@/views/AhMayDashboard4.vue'),
    //component: AhMayDashboard,
    meta: { 
      requiresAuth: false,
      title: '阿美看板4'
    },
    
  },
  */
  {
    path: '/remotedashboard',
    name: 'RemoteDashboard',
    component:()=>import('@/views/RemoteDashboard.vue'),
    //component: AhMayDashboard,
    meta: { 
      requiresAuth: false,
      title: '發送看板資料'
    },
    
  },
  /*
  {
    path: '/ahmaydashboard2',
    name: 'AhmayDashboard2',
    component:()=>import('@/views/AhMayDashboard2.vue'),
    meta: { 
      requiresAuth: true,
      title: '阿美看板'
    },
    
  },
  */
 /*
  {
    path: '/livegridview/:areaId',
    name: 'LiveGridView',
    component:()=>import('@/views/LiveGridView.vue'),
    meta: { 
      requiresAuth: true,
      title: '即時分割影像'
    },
    props: (route) => ({ areaId: Number(route.params.areaId)}),
  },
  {
    path: '/livegridview2/:areaId',
    name: 'LiveGridView2',
    component:()=>import('@/views/LiveGridView20250219.vue'),
    meta: { 
      requiresAuth: true,
      title: '即時分割影像'
    },
    props: (route) => ({ areaId: Number(route.params.areaId)}),
  },
  */
  {
    path: '/editaccessright',
    name: 'EditAccessRight',
    component:()=>import('@/views/EditAccessRight.vue'),
    meta: { 
      requiresAuth: true,
      title: '使用者管理'
    },
    
  },
  {
    path: '/dummy',
    name: 'Dummy',
    component:()=>import('@/views/Dummy.vue'),
    meta: { 
      requiresAuth: true,
      title: '使用者管理'
    },
    
  },
  /*
  {
    path: '/devicestatus',
    name: 'DeviceStatus',
    component:()=>import('@/views/DeviceStatus.vue'),
    meta: { 
      requiresAuth: true,
      title: '設備連線狀態'
    },
    
  },
  */
  /*
  {
    path: '/livegridview/:areaId',
    name: 'LiveGridView',
    component:()=>import('../views/LiveGridView.vue'),
    meta: { 
      requiresAuth: true,
      title: '即時分割影像'
    },
    props: (route) => ({ areaId: Number(route.params.areaId)}),
  },
  */
  
  { path: '/login', 
    name: 'Login', 
    component: Login,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
  
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  //mode: 'hash',
  /*
  // Scroll behavior on route navigation
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { 
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0, behavior: 'smooth' }
  }
  */
})

/*
router.beforeRouteLeave((to, from, next)=> {
  console.log('to',to);
  console.log('from',from);
  //history.replaceState(null, '', from.path);
  next();
});
*/

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  console.log('to',to); 
  console.log('from',from); 
  console.log('next',next); 
  console.log("Navigating to:", to.name);
  console.log("Route Meta:", to.meta);
  //console.log('to.redirectedFrom.fullPath.toLowerCase()',to.redirectedFrom.fullPath.toLowerCase());
  if (to.redirectedFrom!==undefined)
  {
    if (to.redirectedFrom.fullPath.toLowerCase().indexOf("special2")!=-1)
    {
    console.log('navigate to specail2');
    
    //to.fullPath='/Special2';
    next();
    }
    //next('/Special2');
  }
  // Check if the route requires authentication
  else if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    console.log('requiresAut',to.meta.requiresAuth);
    console.log('authStore.isLoggedIn',authStore.isLoggedIn);
    authStore.loginDialogOpen = true; 
    next('/login');
    //next();
  } else {
    console.log('next to route:', to.name);
    //console.log('path',to.path);
    //history.replaceState(null, '', to.path);
    next();
  }
});
/*
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  console.log("to:",to.name);
  console.log("route to", to.meta);

  if (to.meta.requiresAuth && to.path !== '/login' && !authStore.isLoggedIn) {
    authStore.loginDialogOpen = true; 
    next('/login');
  } 
  else {
    console.log('bypass route');
    next();
  }
});
*/

export default router